import {SERVICES} from '@/const/services';

const PREFIX = `${SERVICES.IMG_URL}/v1/`;

export const IMAGES = {
  NEW_BONUS_1: 'a9239e54-c095-4a08-9111-fd86364b72bb/1.svg',
  NEW_BONUS_2: '7667b28b-ac92-4ecb-a33c-14ee2e234595/2.svg',
  NEW_BONUS_3: '350a3713-97c2-4642-8793-dddafbefe925/233.svg',
  NEW_BONUS_4: 'c5667b5f-6d60-4dd4-8ceb-b8a30a4092f7/1.svg',
  NEW_BONUS_5: 'a919774c-2841-46cb-ade5-e7c5bf073715/frame-2082.svg',
  NEW_BONUS_6: '746ce73d-7a49-4e75-81b2-e84b0ff20cb8/frame-1.svg',
  BONUS_KYC: '41199841-13e8-4abc-9654-8d08db80574c/lczy-7-kaeinr-3-c.svg',
  NEW_BONUS_7: '728769e5-0c56-4252-bbb2-90943edb58c8/voucher-2x.png',
  NEW_BONUS_8: '20c2c3ce-713f-4aa8-865d-9643348c632a/bonus-1.gif',
  NEW_BONUS_9: '15b11eb5-67e0-4bac-9191-6529373a6a6c/imags-2x.png',
  NEW_BONUS_10: '5235840e-b302-4a83-bf47-9e4d3447f8ce/bonus-2.gif',
  NEW_BONUS_11: 'e985edd3-1054-4a83-b39c-8cde0824453c/232.svg',
  NEW_BONUS_12: '29c5a60c-a7e0-45a3-ac25-01ea40786a30/voucher-2x.png',
  LEARN_BG: '13599797-b224-40c7-8dc9-22aeb2ba03bf/mask-group-1.svg',
  AWARDS_BOUNS_1: '08d2ad1c-abc5-468b-b95e-c9ac2bce3f5e/rewards-bouns.png',
  AWARDS_BOUNS_SUCCESS_1: '5a1d6228-8098-440c-9ce3-5ef918b593be/box-success.png',
  AWARDS_BOUNS_CLAIM_SUCCESS_1: 'cfbc6928-7735-4ad7-8005-6ef5f2046436/box-award.png',
};

Object.keys(IMAGES).forEach((key) => (IMAGES[key] = [PREFIX, IMAGES[key]].join('')));
